import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import {  useParams, NavLink, useHistory } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider, withStyles} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ReceiptIcon from '@material-ui/icons/Receipt';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import numeral from "numeral";
import MessageBox from "../../components/MessageBox/MessageBox";
import LoadingModal from "../../components/Modal/LoadingModal";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));


const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		root: {
		  '&:nth-child(1)': {
			width: 120
		  },	
		  '&:nth-child(2)': {
			width: 120
		  },
		  '&:nth-child(3)': {
			width: 160
		  },
		  '&:nth-child(4)': {
			width: 160
		  },
		}
	  }
	}
  });


const PurchaseOrderReturnAllocate = () => {
	const { poretno, branchidno } = useParams();
	const [unpaidPo, setUnpaidPo] = useState([]);
	const [allocatePO, setAllocatePO] = useState([]);

	//disable/enable allocate button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});

	//allocate po data
	const [allocateArray, setAllocateArray] = useState([]);
	//eof allocate po data

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	const [showModal, setShowModal] = useState(false);
	//Message Box EOF
	const classes = useStyles();

	let history = useHistory();

	// Data Fetching
	useEffect(() => {
		setDataLoaded(true);
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(allocateArray.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [allocateArray]);


	const data = async () => {
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'get_po_return_allocate', {
            params:{
				poretno: poretno,
                jc_u_idno: branchidno,  
            }
		})
		//console.log(result.data.data[1].unpaid_po_info);
		setAllocatePO(result.data.data[0].po_allocate_info);
		setUnpaidPo(result.data.data[1].unpaid_po_info);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	const updateAllocateArray = (recAmount, pono, unpaidamount) => {
			let found = allocateArray.some(x => x.pono === pono);
			if(found){
				//if item is existing in itemArray, add the qty instead
				let newItems = allocateArray.map((it)=> {
					if(it.pono === pono){ //add
						it.allocated_amount = parseFloat(recAmount);
						//update the allocated amount if it is existing in the state array
					  }
				  return it;
				});
				setAllocateArray(newItems);
			}else{
				setAllocateArray([...allocateArray, 
					//add the new object in the array (for PO allocation)
					{
						allocated_amount: parseFloat(recAmount),
						pono: pono,
						balance: unpaidamount
					}
				]);
			}	
	}

	const removeItem = (pono) => {
		let newItems = allocateArray.filter((it)=>{
			return (it.pono !== pono);
		})
		setAllocateArray(newItems);
	}

	const columns = [
		{
			name: "date",
			label: "Date",
			options: {
				//filter: false,
				// display: "excluded",
			},
		},
		{
			name: "pono",
			label: "PO No.",
		},
		{
			name: "balance",
			label: "balance",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "balance",
			label: "Amount",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let count =  unpaidPo[dataIndex].count;
					let balance =  unpaidPo[dataIndex].balance;
					let pono =  unpaidPo[dataIndex].pono;
// $echo.='<input value="0" onchange="amountAllocatePORet('.$count.','.$unpaidamount.');" type="text" id="poret'.$count.'" name="poret'.$count.'" >';
					// let allocateall =  unpaidPo[dataIndex].allocateall;
					return(
						// <Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<TextField 
									classes={classes.rightTxt}
									placeholder="Enter amount to allocate" 
									// inputProps={{ 'aria-label': 'Amount' }} 
									inputProps={{
										style: { textAlign: "right" },
										min: 0 ,
										'aria-label': 'Amount' 
									  }}
									defaultValue="0"
									type="number"
									id={"poret"+count}
									fullWidth
									onBlur={(e)=> amountAllocatePORet(count, balance, e, pono)}
									onKeyPress={(e) => { 
										if(e.key == '-'){
											e.preventDefault();
										}
									 }}
							/>
						
					);
				}
			}
		},
	];

	const options = {
		//hide toolbar functions
		toolbar:false,
		filter: false,
		viewColumns: false,
		search: false,
		download: false,
		print: false,
		csv: false,
		pagination: false,
		// filterType: "dropdown",
		selectableRows: "none",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	const allocate_po = async () => {
		setShowModal(true); //show loading/please wait modal
		setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("po_allocate_array", JSON.stringify(allocateArray));
		formData.append("supplier_id", allocatePO.supplier_id);
		formData.append("jc_user_id_no", branchidno);
		formData.append("poretno", poretno);
		formData.append("retbalance", allocatePO.balance);
	  
		await axios.post(process.env.REACT_APP_API_URL+'allocate_po', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (response) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("PO Allocation success");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/purchases/purchases-order-allocate-view/'+poretno+'/'+branchidno);
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}


	//const amountAllocatePORet = (count,unpaidamount) =>
	const amountAllocatePORet = (count, unpaidamount, e, pono) =>
	{
	    var fieldID = 'poret'+count;
		var fieldrun = 'poret';
		
		//poretcount = unpaid POs to allocate

		//var retbalance = document.getElementById("retbalance").value; retbalance=retbalance.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
		let retbalance = allocatePO.balance;
		//console.log(typeof retbalance);
		//"retbalance"  = $po_allocate_obj->balance

		//var grandtotal = document.getElementById("grandtotal").value; grandtotal=grandtotal.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
		let grandtotal = allocatePO.grandtotal;
		//console.log(typeof grandtotal);
		//grandtotal = grandtotal in po_allocate_info

		
		//var recAmount = document.getElementById(fieldID).value; recAmount=recAmount.replace(/#/ig,"").replace(/&/ig,"").replace(/'"/ig,"");
		let recAmount = e.target.value;
		//recAmount = value of current item (e.target.value)

	    var diff=0;
	
	    var checker=1;
	    if (recAmount === "")
	    {
	        document.getElementById(fieldID).value=0;
	    }
	    else
	    {
	        if(parseFloat(recAmount) || (recAmount===0))
	        {
	           if (recAmount>unpaidamount)
	           {
	                checker = 3;
			   }
			   // >> safe, amount will not get warped to zero / or no errors
			   //console.log('recAmount not greater than unpaid amount');
			   updateAllocateArray(recAmount, pono, unpaidamount);
	        }
	        else
	        {
	            //document.getElementById(fieldID).value=0;
	        }
	    }
	
	    if (checker===1)
	    {
	        var totalamt=0;
	        for(var a=1; a<=grandtotal; a++)
	        {
	            fieldrun = 'poret'+a;
	            var val = document.getElementById(fieldrun).value;
				totalamt = (totalamt*1)+(val*1);
				//console.log("totalamt: "+totalamt);
	        }
	        diff = (retbalance*1)-(totalamt*1);
			//console.log("diff: "+diff);
	        if (diff>=0)
	        {
	            if(totalamt===0)
	            {
					setBtnDisabled(true);
					//document.getElementById("allocateBtn").disabled = true;
					//console.log("disable allocate");
	            }
	            else
	            {
					setBtnDisabled(false);
					//document.getElementById("allocateBtn").disabled = false;
					//console.log("allocate ready");
	            }
			
	            // totalamt = number_format(totalamt, 2, '.', ','); 
	            // setText('allocLabel',totalamt);
	        }
	        else
	        {
				//alert("ERROR: You have insufficient balance for allocation.");
				setShowMsgBox(true);
				setMsg("ERROR: You have insufficient balance for allocation.");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 2500)
				e.target.value = 0; //set the input field to 0
				removeItem(pono); //remove the item
				//document.getElementById(fieldID).value=0;
					//set the textField amount to zero
	        }
	    }
	    else if (checker===3) 
	    {
			//alert("ERROR: allocated amount is exceeds the unpaid amount.");
			setShowMsgBox(true);
			setMsg("ERROR: allocated amount exceeds the unpaid amount.");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
			e.target.value = 0; //set the input field to 0
			removeItem(pono); //remove the item
			//document.getElementById(fieldID).value=0;
			//set the textField amount to zero
	    }
	    else
	    {
			//render messagebox here
			//alert("ERROR: Please make sure all values entered are correct.");
			setShowMsgBox(true);
			setMsg("ERROR: Please make sure all values entered are correct.");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2500)
			e.target.value = 0; //set the input field to 0
			removeItem(pono); //remove the item
			//document.getElementById(fieldID).value=0;
				//set the textField amount to zero
	    }
	
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-return-transaction-history"}>
				<h2 style={{color:"black"}}>Purchase Order Return Transaction History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2 style={{color:"black"}}>PO Return Allocate # {poretno}</h2>
			</div>
			<div className="page-container">
				<LoadingModal showModal={showModal}/>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<div style={style}>
					<Card style={{marginTop:"4em"}}>
						<CardContent>
								<Grid container spacing={3}>
									<Grid item xs={1} className={classes.infoTitle}>
										Balance:
									</Grid>
									<Grid
										item
										xs={11}
										className={classes.infoContent}
									>
										{numeral(allocatePO.balance).format('0,0.00') || "0.00"}
									</Grid>
								</Grid>
								<Grid container spacing={2} >
									<Grid item xs={1} className={classes.infoTitle}>
										Deliver To: 
									</Grid>
									<Grid
										item
										xs={11}
										className={classes.infoContent}>
										{allocatePO.supplier_name || "Supplier Name"}
									</Grid>
								</Grid>
						</CardContent>
					</Card>	
				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<div className="table-subtitle">Table</div>
									<div className="table-title">
									Purchase Order Return Allocate
									</div>
								</div>
							}
							data={unpaidPo}
							columns={columns}
							options={options}
						/>
				  </MuiThemeProvider>
				// <div>render table here</div>
				)}
					 <Grid container direction="row" justify="flex-end">
						<ColorButton disabled={btnDisabled} style={{marginTop: "22px"}} id="allocateBtn" variant="contained" color="primary"  onClick={() => {allocate_po()}} classes={{
    				root: classes.root, 
        			disabled: classes.disabled}}>Allocate</ColorButton>
					</Grid>   
			</div>
		</div>
	);
};

export default PurchaseOrderReturnAllocate;
